export default "__VITE_ASSET__0sVWbPw3__"